{
  const validate = new window.JustValidate(
    '.form',
    {
      errorLabelCssClass: 'error',
      errorLabelStyle: {
        color: '#D93025',
      },
    });

  validate
    .addField('#name', [
      {
        rule: 'required',
        errorMessage: '名前をご入力ください。',
      },
      {
        rule: 'minLength',
        value: 2,
        errorMessage: '2文字以上にしてください。',
      },
      {
        rule: 'maxLength',
        value: 50,
        errorMessage: '50文字以下にしてください。',
      },
    ])
    .addField('#email', [
      {
        rule: 'required',
        errorMessage: 'メールアドレスをご入力ください。',
      },
      {
        rule: 'email',
        errorMessage: '正しいメールアドレスをご入力ください。',
      },
    ])
    .addField('#phone', [
      {
        rule: 'required',
        errorMessage: '電話番号をご入力ください。',
      },
      {
        rule: 'customRegexp',
        value: /^0[-0-9]{9,12}$/,
        errorMessage: '正しい電話番号をご入力ください。',
      },
    ])
    .addField('#message', [
      {
        rule: 'minLength',
        value: 5,
        errorMessage: '5文字以上にしてください。',
      },
      {
        rule: 'required',
        errorMessage: 'お問い合わせ内容をご入力ください。',
      },
    ])
    .onSuccess(() => {
      document.contact.submit();
    });
}
